import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import avatarFase2Ct1Mp4 from "../../assets/videos/avatar-fase2-ct1.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import "../StartGame.css";
import Scenario2NextCta from "../Scenario2/Scenario2NextCta";
import "./Scenario3.css";

const WITNESS_STATEMENT =
	"Acababa de salir del bar que hay al final de la plaza.\n\nLlevaba el bolso colgado al hombro y, cuando fui a buscar la cartera, ya no estaba.\n\nDentro tenía mi DNI, varias tarjetas bancarias y algo de dinero en efectivo.\n\nNo puedo asegurar que lo haya visto cogerla, pero ese hombre estaba muy cerca de mí hace unos minutos.\n\nCuando me di cuenta de que me faltaba la cartera, le pregunté si la había visto y empezó a ponerse a la defensiva.\n\nEstoy convencida de que tiene algo que ver, aunque no sé dónde puede estar la cartera ahora mismo.";

/** ms entre cada carácter (ritmo mecanográfico). */
const TYPEWRITER_MS_PER_CHAR = 70;

export default function Scenario3Context1() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);
	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 1.0,
	});

	const [visibleLen, setVisibleLen] = useState(0);
	const typingComplete = visibleLen >= WITNESS_STATEMENT.length;

	useEffect(() => {
		const id = window.setInterval(() => {
			setVisibleLen((n) => {
				const next = n + 1;
				if (next >= WITNESS_STATEMENT.length) {
					window.clearInterval(id);
					return WITNESS_STATEMENT.length;
				}
				return next;
			});
		}, TYPEWRITER_MS_PER_CHAR);
		return () => window.clearInterval(id);
	}, []);

	const displayed = WITNESS_STATEMENT.slice(0, visibleLen);

	return (
		<div className="start-game-page start-game-page--welcome sc3-context1-dialogue-page">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Escenario 3 · Evolución
						</span>
						<div className="start-game-avatar-wrap sc3-context1-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									muted={!canPlayWithSound}
									playsInline
									preload="metadata"
									aria-label="Testigo: declaración en vídeo"
								>
									<source src={avatarFase2Ct1Mp4} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>

					<div className="start-game-panel sc3-context1-dialogue-panel">
						<p className="start-game-kicker sc3-context1-kicker">Testimonio</p>
						<p className="start-game-lead sc3-context1-typewriter" aria-live="polite">
							{displayed}
							{typingComplete ? null : (
								<span className="sc3-context1-caret" aria-hidden>
									▍
								</span>
							)}
						</p>
						<div className="start-game-footer sc3-context1-footer">
							<Scenario2NextCta
								navigateTo={ROUTES.SCENARIO3_QUIZ1}
								activeScenario={activeScenario}
								label="Continuar"
								canContinue={typingComplete}
								lockedTitle="Espera a que termine el testimonio para continuar"
							/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}
